import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Switch, Route } from 'react-router-dom';
import {
  JoinPage,
  SessionPage,
  LoginPage,
  NotFoundPage,
  InterpreterPage,
  OrganizationPage,
  ProtectedRoute,
} from './components';
import Rest from './utils/rest/rest';

const App = () => {
  const dispatch = useDispatch();
  const [restInitDone, setRestDone] = useState(false);

  useEffect(() => {
    // init rest
    Rest.init(dispatch);
    setRestDone(true);
  }, [dispatch]);

  if (!restInitDone) {
    return null;
  }

  return (
    <Switch>
      <Route exact path="/login">
        <LoginPage registration={false} />
      </Route>
      <Route exact path="/create-account">
        <LoginPage registration={true} />
      </Route>
      <Route exact path="/join/:sessionId" component={JoinPage} />
      <Route exact path="/session/:sessionId" component={SessionPage} />
      <ProtectedRoute exact path="/interpreter-session/:sessionId" component={SessionPage} />
      <ProtectedRoute exact path="/" component={InterpreterPage} />
      <ProtectedRoute exact path="/interpreter" component={InterpreterPage} />
      <ProtectedRoute exact path="/organization" component={OrganizationPage} />
      <ProtectedRoute exact path="/organization/:organizationId" component={OrganizationPage} />
      <Route component={NotFoundPage} />
    </Switch>
  );
};

export default App;
